import { type SchemaDefinition } from 'validate';

const matrix = {
    type: 'object',
    required: false,
    horizontal: {
        type: 'array',
        required: false,
        each: 'string',
    },
    vertical: {
        type: 'array',
        required: false,
        each: 'string',
    },
    values: {
        type: 'array',
        required: false,
        each: {
            type: 'array',
            each: 'string',
        },
    },
};

export const schema: SchemaDefinition = {
    documentID: {
        type: 'string',
    },
    matrix: {
        type: 'object',
        required: true,
        likelihood: matrix,
        risk: matrix,
    },
};
